import React, { Component } from 'react';
import { CCOButton, SectionHeader } from './util/Components.js';
import firebase from 'firebase';
import './styles/index.css';

class DovePicker extends Component {
  constructor(props) {
    super(props)

    this.state = {
      color: "Red",
      previewLinks: {}
    }

    this.colors = ["Red", "Blue", "Black", "White", "Gray"]
    this.colorMap = {
      "Red": "#AA1717",
      "Blue": "#1C2AD6",
      "Black": "#000000",
      "White": "#FFFFFF",
      "Gray": "#878787"
    }

    let storageRef = firebase.storage().ref()
    this.colors.forEach(color => {
      storageRef.child('images').child("CCO-Dove-" + color + "-" + this.props.version + "-Preview.png").getDownloadURL().then(url => {
        let urls = this.state.previewLinks;
        urls[color] = url;
        this.setState({previewLinks: urls})
      })
    })
  }

  downloadImage(png=true) {
    let storageRef = firebase.storage().ref()
    let filename = "CCO-Dove-" + (png ? this.state.color + "-" : "") + this.props.version + "." + (png ? "png" : "eps")
    storageRef.child('images').child(filename).getDownloadURL().then(url => {
      let a = document.createElement('a');
      a.href = url;
      a.download = filename;
      a.click();
    })
  }

  render() {
    return (
      <div style={{width: 200, display: 'inline-block', margin: 5}}>
        <div style={{backgroundColor: '#dddddd', marginBottom: 10}}><img alt={this.props.version + " Dove"} src={this.state.previewLinks[this.state.color]} style={{width: 200}} /></div>
        <center>
          {this.colors.map(color => (
            <div 
              key={color}
              className={"colorSelector" + (color === this.state.color ? " colorSelectorSelected" : "")}
              style={{backgroundColor: this.colorMap[color]}} 
              onClick={() => this.setState({color})} 
            />
          ))}
        </center>
        <CCOButton
          text={"Download PNG"}
          onClick={() => this.downloadImage(true)}
        />
        <div style={{height: 5}} />
        <CCOButton
          text={"Download EPS"}
          onClick={() => this.downloadImage(false)}
        />
      </div>
    )
  }
}

class BannerImage extends Component {
  constructor(props) {
    super(props)

    this.state = {
      previewLink: null
    }

    let storageRef = firebase.storage().ref()
    storageRef.child('images').child("CCO-Banner-" + props.name + "-Preview.png").getDownloadURL().then(url => {
      this.setState({previewLink: url})
    })
  }

  downloadImage(png=true) {
    let storageRef = firebase.storage().ref()
    let filename = "CCO-Banner-" + this.props.name + "." + (png ? "png" : "eps")
    storageRef.child('images').child(filename).getDownloadURL().then(url => {
      let a = document.createElement('a');
      a.href = url;
      a.download = filename;
      a.click();
    })
  }

  render() {
    return (
      <div style={{width: 200, display: 'inline-block', margin: 5}}>
        <div style={{backgroundColor: '#dddddd', marginBottom: 10}}><img alt={this.props.name + " Banner"} src={this.state.previewLink} style={{width: 200}} /></div>
        <CCOButton
          text={"Download PNG"}
          onClick={() => this.downloadImage(true)}
        />
        <div style={{height: 5}} />
        <CCOButton
          text={"Download EPS"}
          onClick={() => this.downloadImage(false)}
        />
      </div>
    )
  }
}

export default class Resources extends Component {

  constructor(props) {
    super(props);

    this.state = {
      previewLinks: {}
    }

    this.doveVersions = ["Open", "Filled", "Plain"]

    this.premadeDoves = []
    this.banners = ["Plain", "Filled"]

    this.fonts = [
      "Lato Hairline",
      "Lato Thin",
      "Lato Light",
      "Lato Regular",
      "Lato Medium",
      "Lato Semibold",
      "Lato Bold",
      "Lato Heavy",
      "Lato Black"
    ]

    this.colors = {
      "Red": {
        hex: "#AA1717",
        red: 170,
        green: 23,
        blue: 23 
      },
      "Dark Red": {
        hex: "#650000",
        red: 101,
        green: 0,
        blue: 0
      },
      "Light Red": {
        hex: "#C90210",
        red: 201,
        green: 2,
        blue: 16
      }
    }
  }

  downloadImage(name) {
    let storageRef = firebase.storage().ref()
    storageRef.child('images').child(name + ".png").getDownloadURL().then(url => {
      let a = document.createElement('a');
      a.href = url;
      a.download = name + ".png";
      a.click();
    })
  }

  downloadFont(fontName, italic=false) {
    let storageRef = firebase.storage().ref()
    storageRef.child('fonts').child(fontName.replace(" ", "-") + (italic ? "Italic" :"") + ".ttf").getDownloadURL().then(url => {
      let a = document.createElement('a');
      a.href = url;
      a.download = fontName + ".ttf";
      a.click();
    })
  }

  render() {

    return (
      <center>
        <div style={{padding: 10}}>
          <section>
            <SectionHeader title="Doves" />
            {this.doveVersions.map(version => <DovePicker key={version} version={version} />)}
          </section>
          <p className="resourcesSubtext">PNG = High quality image, transparent background</p>
          <p className="resourcesSubtext">EPS = Vector image file, import into drawing program for customization</p>
          <div style={{clear: 'both'}} />
          <section>
            <SectionHeader title="Banners" />
            {this.banners.map(name => <BannerImage key={name} name={name} />)} 
          </section>
          <section style={{maxWidth: 500}}>
            <SectionHeader title="Colors" />
            <center>
              {Object.keys(this.colors).map(color => (
                <div key={color} style={{display: 'inline-block'}}>
                  <p style={{fontSize: 16, margin: 10, width: 70, float: 'left', textAlign: 'right'}}>{color}</p>
                  <div style={{width: 40, height: 40, backgroundColor: this.colors[color].hex, marginLeft: 20, marginRight: 20, float: 'left'}} />
                  <p style={{margin: 10, width: 100, float: 'left', textAlign: 'left'}}>Hex: {this.colors[color].hex}</p>
                  <p style={{margin: 10, width: 120, float: 'left', textAlign: 'left'}}>RGB: ({this.colors[color].red}, {this.colors[color].green}, {this.colors[color].blue})</p>
                </div>
              ))}
            </center>
          </section>
          <div style={{clear: 'both'}} />
          <section style={{maxWidth: 600}}>
            <SectionHeader title="Fonts" />
            {this.fonts.map(fontName => (
              <div key={fontName} style={{display: 'inline-block', width: 420}}>
                <p style={{width: 130, textAlign: 'right', margin: 10, float: 'left'}}>{fontName}</p>
                <div style={{width: 250, float: 'right'}}>
                  <div style={{width: 100, float: 'left', marginRight: 20}}><CCOButton text="Regular" onClick={() => this.downloadFont(fontName)} /></div>
                  <div style={{width: 100, float: 'left'}}><CCOButton text="Italic" onClick={() => this.downloadFont(fontName, true)} /></div>
                </div>
              </div>
            ))}
          </section>

        </div>
      </center>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/Resources.js
 **/